import useCategorySortFilter from '@/components/CategoryPage/useCategorySortFilter'

interface CategoryProductSortProps {
  className?: string
}

const CategoryProductSort = ({ className }: CategoryProductSortProps) => {
  const {
    handleChangeSort,
    handleChangeCustomSort,
    isCustomSortActive,
    isSortActive,
  } = useCategorySortFilter()

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <button
        className={`flex h-9 items-center justify-center rounded-xl border px-6 text-sm ${
          isCustomSortActive('shouldBuy')
            ? 'border-primary bg-[#F0F2FF] font-semibold text-primary'
            : 'border-[#D1D5DB] bg-[#F9F9F9] text-main'
        }`}
        onClick={() => handleChangeCustomSort('shouldBuy')}
      >
        <span>Nên mua</span>
      </button>
      <button
        className={`flex h-9 items-center justify-center rounded-xl border px-6 text-sm  ${
          isCustomSortActive('bestSelling')
            ? 'border-primary bg-[#F0F2FF] font-semibold text-primary'
            : 'border-[#D1D5DB] bg-[#F9F9F9] text-main'
        }`}
        onClick={() => handleChangeCustomSort('bestSelling')}
      >
        <span>Bán chạy</span>
      </button>
      <button
        className={`flex h-9 items-center justify-center rounded-xl border px-6 text-sm  ${
          isSortActive('asc')
            ? 'border-primary bg-[#F0F2FF] font-semibold text-primary'
            : 'border-[#D1D5DB] bg-[#F9F9F9] text-main'
        }`}
        onClick={() => handleChangeSort('asc')}
      >
        <span>Giá tăng dần</span>
      </button>
      <button
        className={`flex h-9 items-center justify-center rounded-xl border px-6 text-sm  ${
          isSortActive('desc')
            ? 'border-primary bg-[#F0F2FF] font-semibold text-primary'
            : 'border-[#D1D5DB] bg-[#F9F9F9] text-main'
        }`}
        onClick={() => handleChangeSort('desc')}
      >
        <span>Giá giảm dần</span>
      </button>
    </div>
  )
}

export default CategoryProductSort
